<div
  *ngIf="colVm.columnType === Types.SectionColumnProductInfoType.Lineage"
  class="product-column-general product-lineage"
  [style.visibility]="section?.collapseContent || rowVm.collapseContent ? 'collapse' : ''"
  [style.text-decoration]="productStylingVm | forcedColumnTextDecoration: colVm : locConfig | async"
  [style.margin-right]="menu | productMenuBasicMethod: 'getSectionBorderMarginSize'">
  {{ rowVm | sectionRowViewModelBasicMethod: 'getLineage' }}
</div>
